import { useMemo } from 'react';

import { useRoutes } from '../../../hooks/useRoutes';

export function usePaths() {
  const routes = useRoutes();

  return useMemo(() => {
    const paths = [];

    for (const route of routes) {
      if (route.path) {
        paths.push({
          path: route.path,
          exact: !!route.exact,
          component: route.component,
        });
      }

      if (route.children) {
        for (const child of route.children) {
          if (child.path) {
            paths.push({
              path: child.path,
              exact: !!child.exact,
              component: child.component,
            });
          }
        }
      }
    }

    return paths;
  }, [routes]);
}
